/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Search_ResultsInputs */

const en_fix_search_results = /** @type {(inputs: Fix_Search_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching ingredients`)
};

const de_fix_search_results = /** @type {(inputs: Fix_Search_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passende Zutaten`)
};

/**
* | output |
* | --- |
* | "Matching ingredients" |
*
* @param {Fix_Search_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_search_results = /** @type {((inputs?: Fix_Search_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Search_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_search_results(inputs)
	return en_fix_search_results(inputs)
});